import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AppLogoWithTitle from '../Components/Common/AppLogoWithTitle';
import { ForceTheme } from '../Components/Common/ForceTheme';
const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100vw',
        ...shorthands.gap('2rem'),
        backgroundColor: tokens.colorNeutralBackground1,
    },
});
export const PageTurnYourDevice: FC = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <ForceTheme theme='dark'>
            <div className={classes.root}>
                <AppLogoWithTitle collapsed={false} />
                <h1>{t('TurnDevice')}</h1>
            </div>
        </ForceTheme>
    );
};
